import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders assistant chat text as GitHub-flavored Markdown (headings, lists,
 * bold, horizontal rules, tables, etc.). Safe by default (no raw HTML pass-through).
 */
export function ChatMarkdown({ content }) {
  if (content == null || content === "") {
    return null;
  }

  return (
    <div className="message-content message-content--markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
}
